// extracted by mini-css-extract-plugin
module.exports = {"bonus":"_4070","text":"_5126","icon":"_11386"};